import { render } from "./FooterInformation.vue?vue&type=template&id=1034b808&scoped=true"
import script from "./FooterInformation.vue?vue&type=script&lang=js"
export * from "./FooterInformation.vue?vue&type=script&lang=js"

import "./FooterInformation.vue?vue&type=style&index=0&id=1034b808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1034b808"]])

export default __exports__